import { Listing } from '@/utils/platform-api/__generated__/graphql';
import { ClientBrandConfig } from 'types/brand-config';

import DateRangePopover from './date-range-popover';

interface DateRangePopoverWrapperProps {
  children: React.ReactNode;
  className?: string;
  brand: ClientBrandConfig;
  listing: Listing;
}

const DateRangePopoverWrapper: React.FC<DateRangePopoverWrapperProps> = ({
  children,
  className,
  brand,
  listing,
}) => {
  return (
    <div className={className}>
      <DateRangePopover
        brand={brand}
        calendarDates={listing?.calendar_dates || []}
        numberOfMonths={2}
        direction="horizontal"
        pickerClassname="!-left-2/3"
        popoverClassName="hidden lg:block"
      >
        {children}
      </DateRangePopover>
      <DateRangePopover
        modal
        brand={brand}
        calendarDates={listing?.calendar_dates || []}
        numberOfMonths={12}
        direction="vertical"
        hideNavigation
        hideWeekdays={false}
        popoverClassName="block lg:hidden"
      >
        {children}
      </DateRangePopover>
    </div>
  );
};

export default DateRangePopoverWrapper;
